import fetch from '@/utils/fetch';

export function enterpriseCreate(params) {
  return fetch({
    url: 'Qiye/Qiye/saveEnterprise',
    method: "post",
    data: params
  });
}

export function addressSave(params) {
  return fetch({
    url: 'Qiye/Qiye/batchSaveEnterpriseOfficeAddress',
    method: "post",
    data: params
  });
}

export function serviceSave(params) {
  return fetch({
    url: 'Qiye/Qiye/batchSaveEnterpriseBusinessAdvisory',
    method: "post",
    data: params
  });
}

export function entMemberRemove(params) {
  return fetch({
    url: 'Qiye/Qiye/batchDeleteEnterprisePerson',
    method: "post",
    data: params
  });
}

export function enterpriseRemove(params) {
  return fetch({
    url: 'Qiye/Qiye/batchDeleteEnterprise',
    method: "post",
    data: params
  });
}

export function getEnterprise(params) {
  return fetch({
    url: 'Qiye/Qiye/getEnterpriseById',
    method: "post",
    data: params
  });
}

export function pkCreate(query) {   // 商协会
    return fetch({
        url: '/Qiye/Qiye/saveEnterpriseServicePack',
        method: 'post',
        data: query
    });
}

export function pkPredat(query) {
    return fetch({
        url: '/Qiye/Qiye/getEnterpriseServicePackById',
        method: 'post',
        data: query
    });
}

export function pkList(query) {
    return fetch({
        url: '/Qiye/Qiye/getEnterpriseServicePackByWhere',
        method: 'post',
        data: query
    });
}

export function pkRemove(query) {
    return fetch({
        url: '/Qiye/Qiye/batchDeleteEnterpriseServicePack',
        method: 'post',
        data: query
    });
}

export function pkStatusSet(query) {
    return fetch({
        url: '/Qiye/Qiye/updateStatusEnterpriseServicePack',
        method: 'post',
        data: query
    });
}

export function goEntMetts(query) {
    return fetch({
        url: '/Qiye/Qiye/saveEnterpriseCertificationInfo',
        method: 'post',
        data: query
    });
}

export function getEntUser(query) {
    return fetch({
        url: '/Qiye/Qiye/getEnterprisePersonByWhere',
        method: 'post',
        data: query
    });
}

export function createEntUser(query) {
    return fetch({
        url: '/Qiye/Qiye/saveEnterprisePerson',
        method: 'post',
        data: query
    });
}

export function entUserItem(query) {
    return fetch({
        url: '/Qiye/Qiye/getEnterprisePersonById',
        method: 'post',
        data: query
    });
}

export function removeEntUser(query) {
    return fetch({
        url: '/Qiye/Qiye/batchDeleteEnterprisePerson',
        method: 'post',
        data: query
    });
}

export function matchList(query) {
    return fetch({
        url: '/Sbzc/Sbzc/getDeclareMyMatchConditionsJoinByFileds',
        method: 'post',
        data: query
    });
}

export function getMatchs(query) {
    return fetch({
        url: '/Sbzc/Sbzc/getDeclareMyMatchConditionsByUserId',
        method: 'post',
        data: query
    });
}

export function matchPocs(query) {
    return fetch({
        url: '/Sbzc/Sbzc/getMyMatchPolicyByConditions',
        method: 'post',
        data: query
    });
}

export function requireList(query) {
    return fetch({
        url: '/Shangxun/Shangxun/getMyDemandCustomizationByCondition',
        method: 'post',
        data: query
    });
}

export function requireItem(query) {
    return fetch({
        url: '/Shangxun/Shangxun/getMyDemandCustomizationById',
        method: 'post',
        data: query
    });
}

export function requireListSave(query) {
    return fetch({
        url: '/Shangxun/Shangxun/batchSaveMyDemandCustomizationEnterprise',
        method: 'post',
        data: query
    });
}

export function requireEntList(query) {
    return fetch({
        url: '/Shangxun/Shangxun/getMyDemandCustomizationEnterpriseByCondition',
        method: 'post',
        data: query
    });
}

export function requireRemove(query) {
    return fetch({
        url: '/Shangxun/Shangxun/batchDeleteMyDemandCustomization',
        method: 'post',
        data: query
    });
}

export function userUpdate(query) {
    return fetch({
        url: '/User/User/updateUser',
        method: 'post',
        data: query
    });
}

export function changePhone(query) {
    return fetch({
        url: '/User/User/changePhone',
        method: 'post',
        data: query
    });
}



// WEBPACK FOOTER //
// ./src/api/enterprise/index.js